import React from 'react';

import { StockCarCardSkeletonProps } from './types';
import Portrait from './components/Portrait';
import Landscape from './components/Landscape';

function StockCarCardSkeleton({
  view = 'portrait',
}: StockCarCardSkeletonProps) {
  return view === 'portrait' ? <Portrait /> : <Landscape />;
}

export default StockCarCardSkeleton;
